import type { UTCDate } from '@date-fns/utc';
import { CalendarIcon } from '@heroicons/react/20/solid';
import { format } from 'date-fns';

export type BettablePickemsHeadProps = {
  totalPickems: number;
  date: UTCDate;
};

export const BettablePickemsHead = ({ date }: BettablePickemsHeadProps) => {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
      <h2 className="font-semibold text-xl">GOCORE MatchDay</h2>
      <div className="flex items-center gap-2 text-sm">
        <CalendarIcon className="h-5 w-5" />
        <span>{format(date, 'd. MMM, yyyy')}</span>
      </div>
    </div>
  );
};
